import React, { useEffect, useRef } from 'react';
import { getFeedsData } from '../../../datafetchers/HomePage';
import { ViewAllButtonVerm } from '../../StoreCategoryPage/ViewAllProducts/styled';

export default function LoadMore(props) {
  const {
    mutate,
    tabData,
    selectedTab,
    setShowLoader,
    tagId,
    setNewData,
    setHideLoadMore,
    initialPageCount,
  } = props;
  const pageCount = useRef(initialPageCount);
  const perPageElementCount = useRef(initialPageCount);
  useEffect(() => {
    pageCount.current = initialPageCount;
  }, [selectedTab?.key]);
  const getDataOnTabClick = () => {
    pageCount.current = pageCount.current + 1;
    setShowLoader(true);
    getFeedsData({
      tag: tagId,
      page: pageCount?.current,
      type: selectedTab?.key == 'questions' ? 'post' : selectedTab?.key,
      shortenFeedResponse: true,
    }).then((response) => {
      const oldData = selectedTab?.items;
      const finalData = [...oldData, ...response?.data?.posts?.items];
      perPageElementCount.current = response?.data?.posts?._meta?.perPage;
      const data = {
        items: finalData,
        key: selectedTab?.key,
      };
      mutate(data, false);
      setNewData(data);
      setShowLoader(false);
      if (response?.data?.posts?.items?.length < perPageElementCount.current) {
        setHideLoadMore(true);
      }
    });
  };
  return (
    <ViewAllButtonVerm width="260px" onClick={() => getDataOnTabClick()}>
      Load More
    </ViewAllButtonVerm>
  );
}
